import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey, monthData } from "./data";
import AddTask from "./addTask";

const MySwal = withReactContent(Swal2);

const TaskCalendar = (props) => {
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(new Date());
  const [tasks, setTasks] = useState([]);
  const [monthName, setMonthName] = useState("");
  const [users, setUsers] = useState([]);
  const [leads, setLeads] = useState([]);
  const [showTask, setShowTask] = useState(false);
  const [showTaskId, setShowTaskId] = useState("");

  const fetchLeadsAss = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getLeadsAssData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data);
        props.user.role === "admin" ? fetchTasks() : fetchTasksUser();
      })
      .catch((error) => {});
  };

  const fetchLeadsAssUser = async () => {
    var body = { user: props.user.id };

    await fetch("https://apisplit.ftpeople.pl/getLeadsAssUserData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data);
        props.user.role === "admin" ? fetchTasks() : fetchTasksUser();
      })
      .catch((error) => {});
  };

  const fetchTasks = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getTasks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasks(data);
        fetchUsersList();
      })
      .catch((error) => {});
  };

  const fetchTasksUser = async () => {
    var body = { user: props.user.id };

    await fetch("https://apisplit.ftpeople.pl/getTasksUser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasks(data);
        fetchUsersList();
      })
      .catch((error) => {});
  };

  const fetchUsersList = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getUsersList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    setMonthName(getMonthData(month) + " " + year);

    props.user.role === "admin" ? fetchLeadsAss() : fetchLeadsAssUser();
  };

  const subtractMonths = (numOfMonths) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() - 1));

    setDate(retDate);
  };

  const addMonths = (numOfMonths) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() + 1));

    setDate(retDate);
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;
    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else {
      return new Date(y, 0, d);
    }
  };

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const createMonthSet = () => {
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var begin = new Date(year, month - 1, 1);
    var end = new Date(year, month, 0);
    var startYear = new Date(date).getFullYear();
    var yearStartDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((begin - yearStartDate) / (24 * 60 * 60 * 1000));
    var weekNumber = 0;
    if (
      new Date(
        new Date(date).getFullYear(),
        new Date(date).getMonth(),
        1
      ).getDay() === 1
    ) {
      weekNumber = Math.ceil(days / 7) + 1;
    } else {
      weekNumber = Math.ceil(days / 7);
    }
    var daysEnd = Math.floor((end - yearStartDate) / (24 * 60 * 60 * 1000));
    var weekNumberEnd = Math.ceil(daysEnd / 7);
    var startDate = getDateOfWeek(weekNumber, startYear);
    var endDate = addDays(getDateOfWeek(weekNumberEnd, startYear), 6);

    var lastDay = end.getDate();
    var daysArray = [];
    var beginCounter = startDate;
    while (beginCounter >= startDate && beginCounter <= endDate) {
      daysArray.push(
        `${beginCounter.getFullYear()}-${
          beginCounter.getMonth() < 10
            ? "0" + (beginCounter.getMonth() + 1)
            : beginCounter.getMonth() + 1
        }-${
          beginCounter.getDate() < 10
            ? "0" + beginCounter.getDate()
            : beginCounter.getDate()
        }`
      );
      beginCounter.setDate(beginCounter.getDate() + 1);
    }

    return daysArray;
  };

  const getMonthData = (monthNum) => {
    var data = monthData.filter((el) => +el.id === monthNum);
    return data.length > 0 ? data[0].name : "";
  };

  const getMonthName = () => {
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;

    return getMonthData(month) + " " + year;
  };

  const setDateNav = (e) => {
    setLoading(true);
    if (e.target.value === "next") {
      addMonths();
    } else if (e.target.value === "previous") {
      subtractMonths();
    }

    getData();
  };

  const getTasks = (date) => {
    var tasksR = [];

    tasksR = tasks.filter(
      (el) =>
        new Date(el.date).getFullYear() === date.getFullYear() &&
        new Date(el.date).getDate() === date.getDate() &&
        new Date(el.date).getMonth() === date.getMonth()
    );

    return tasksR.length > 0 ? tasksR : [];
  };

  const handleShowTask = (e) => {
    setShowTaskId(e.currentTarget.value);
    setShowTask(true);
  };

  const closeShowTask = () => {
    setShowTask(false);
    getData();
  };

  const createTaskButton = (task) => {
    return (
      <>
        {showTask ? (
          <>
            <AddTask
              mode={"edit"}
              task={tasks.filter((task) => +task.id === +showTaskId)[0]}
              user={props.user}
              close={closeShowTask}
            />
          </>
        ) : (
          ""
        )}
        <button
          key={task.id}
          style={{
            backgroundColor: task.status === "WYKONANE" ? "green" : "blue",
            borderRadius: "5px",
            width: "100%",
            color: "white",
            border: "1px solid white",
            textAlign: "left",
            cursor: "pointer",
          }}
          className="caseLink"
          value={task.id}
          onClick={handleShowTask}
        >
          <div className="titleBox">
            <div className="titleBox_col1">
              {task.task}{" "}
              <span style={{ fontSize: ".5vw" }}>
                {leads.length === 0
                  ? ""
                  : leads.filter((lead) => +lead.id === +task.leadId)[0].name}
              </span>
            </div>
            <div className="titleBox_col2"></div>
          </div>
        </button>
      </>
    );
  };

  const calendarMonthNew = (
    <>
      <div style={{ padding: "0" }} className="navigationCalendar">
        <>
          <div className="sectionTitleCalendar">{getMonthName()}</div>
          <button
            className="navigationArrow"
            value="previous"
            onClick={setDateNav}
          >
            &#8592;
          </button>
          <button className="navigationArrow" value="next" onClick={setDateNav}>
            &#8594;
          </button>
        </>
      </div>
      <div className="rowCalendar">
        <div
          className="cellCalendar"
          style={{
            backgroundColor: "transparent",
            border: "none",
            height: "100%",
            textAlign: "center",
            fontWeight: "600",
            marginTop: "2vh",
          }}
        >
          PONIEDZIAŁEK
        </div>
        <div
          className="cellCalendar"
          style={{
            backgroundColor: "transparent",
            border: "none",
            height: "100%",
            textAlign: "center",
            fontWeight: "600",
            marginTop: "2vh",
          }}
        >
          WTOREK
        </div>
        <div
          className="cellCalendar"
          style={{
            backgroundColor: "transparent",
            border: "none",
            height: "100%",
            textAlign: "center",
            fontWeight: "600",
            marginTop: "2vh",
          }}
        >
          ŚRODA
        </div>
        <div
          className="cellCalendar"
          style={{
            backgroundColor: "transparent",
            border: "none",
            height: "100%",
            textAlign: "center",
            fontWeight: "600",
            marginTop: "2vh",
          }}
        >
          CZWARTEK
        </div>
        <div
          className="cellCalendar"
          style={{
            backgroundColor: "transparent",
            border: "none",
            height: "100%",
            textAlign: "center",
            fontWeight: "600",
            marginTop: "2vh",
          }}
        >
          PIĄTEK
        </div>
        <div
          className="cellCalendar"
          style={{
            backgroundColor: "transparent",
            border: "none",
            height: "100%",
            textAlign: "center",
            fontWeight: "600",
            marginTop: "2vh",
          }}
        >
          SOBOTA
        </div>
        <div
          className="cellCalendar"
          style={{
            backgroundColor: "transparent",
            border: "none",
            height: "100%",
            textAlign: "center",
            fontWeight: "600",
            marginTop: "2vh",
          }}
        >
          NIEDZIELA
        </div>
      </div>
      <div className="rowCalendar">
        {createMonthSet().map((el) => (
          <>
            <div
              key={el}
              className="cellCalendar"
              style={{
                padding: "5px",
                border:
                  (new Date(el).getMonth() + 1 < 10
                    ? "0" + (new Date(el).getMonth() + 1)
                    : new Date(el).getMonth() + 1) +
                    "-" +
                    (new Date(el).getDate() < 10
                      ? "0" + new Date(el).getDate()
                      : new Date(el).getDate(el)) ===
                  (new Date().getMonth() + 1 < 10
                    ? "0" + (new Date().getMonth() + 1)
                    : new Date().getMonth() + 1) +
                    "-" +
                    (new Date().getDate() < 10
                      ? "0" + new Date().getDate()
                      : new Date().getDate())
                    ? "4px solid black"
                    : "",
              }}
            >
              <div
                id={"cb" + new Date(el).getDate()}
                className="cellBox"
                style={{ maxHeight: "18vh" }}
              >
                {getTasks(new Date(el)).map((t) => (
                  <>{createTaskButton(t, el)}</>
                ))}
              </div>

              <span className="cellDayNumber">{el}</span>
            </div>
          </>
        ))}
      </div>
    </>
  );

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div
            style={{
              position: "fixed",
              backgroundColor: "white",
              width: "75vw",
              top: "0",
              paddingTop: "5vh",
              paddingBottom: "3vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
              zIndex: "99999",
            }}
          >
            <div
              style={{ display: "flex", justifyContent: "left", gap: "1vw" }}
            >
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "green",
                  borderColor: "green",
                  width: "180px",
                }}
                onClick={getData}
              >
                ODŚWIEŻ
              </button>
            </div>
          </div>
          <div
            style={{
              paddingTop: "10vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            {calendarMonthNew}
          </div>
        </>
      )}
    </>
  );
};

export default TaskCalendar;
